import * as _ from 'underscore';
import 'Navgoco/src/jquery.cookie.min';
import 'Navgoco/src/jquery.navgoco.min';

export default function (el, options) {
    $('.toggle-nav').click(function (e) {
        if ($(this).attr('href') === '#') {
            e.preventDefault();
        }
        $('#page').toggleClass('navigating');
        $('.top-bar').toggleClass('expanded');
        $('body').toggleClass('no-scroll-x');
    });

    let CONFIG = {
        caretHtml: '',
        accordion: true,
        openClass: 'open',
        save: true,
        cookie: {
            name: 'navgoco',
            expires: false,
            path: '/'
        },
        slide: {
            duration: 400,
            easing: 'swing'
        }
    };
    $(el).navgoco(_.extend(CONFIG, options));
};
